// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2ed79199","453":"67aeea00","455":"35dadb64","977":"0415b37a"}[chunkId] + ".chunk.js";
};